import { dispatch } from './dispatcher';
import createActionId from './createActionId';
export function actionCreator(actionType, target) {
    return createActionCreator(actionType, target, false);
}
export function action(actionType, target) {
    return createActionCreator(actionType, target, true);
}
function createActionCreator(actionType, target, shouldDispatch) {
    var actionId = createActionId();
    var decoratedTarget = function createAction() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var actionMessage = target ? target.apply(null, args) : {};
        if (actionMessage.type) {
            throw new Error('Action creators should not include the type property.');
        }
        actionMessage.type = actionType;
        setPrivateActionId(actionMessage, actionId);
        if (shouldDispatch) {
            dispatch(actionMessage);
        }
        return actionMessage;
    };
    setPrivateActionId(decoratedTarget, actionId);
    setActionType(decoratedTarget, actionType);
    return decoratedTarget;
}
export function getPrivateActionId(target) {
    return target.__SATCHELJS_ACTION_ID;
}
function setPrivateActionId(target, actionId) {
    target.__SATCHELJS_ACTION_ID = actionId;
}
export function getPrivateActionType(target) {
    return target.__SATCHELJS_ACTION_TYPE || 'unknown action';
}
function setActionType(target, actionType) {
    target.__SATCHELJS_ACTION_TYPE = actionType;
}
